import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  checklistTemplateKeys,
  checklistTemplateEditorMutationKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import { ITaskTemplateVersion } from '@core/entities/task/TaskTemplateVersion'

export const useUpdateChecklistTemplateVersionWarning = (
  options?: UseMutationOptions<
    ITaskTemplateVersion,
    RequestErrorType,
    RequestTypes['updateChecklistTemplateVersionWarning']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...checklistTemplateEditorMutationKeys.updateChecklistTemplateVersionWarning,
    ...options,
    onSuccess: (_, variables) => {
      const queryKey = checklistTemplateKeys.getVersion({
        templateId: variables.templateId,
        templateVersionId: variables.versionId,
      }).queryKey

      queryClient.invalidateQueries({ queryKey })
    },
  })
}
